export const navigationGetTitle = (data: object, locale: string) => {
  if (!data) { return }
  const titles = {
    title_en: data?.title,
    title_nl: data?.title_nl
  }
  return titles[`title_${locale}`] || data?.title
}
